import { PlusCircleIcon } from "@/components/Icons/PlusCircleIcon";
import { Button } from "@/design-system/Button";

export function AddProjectButton({
  children,
  onClick,
}: React.PropsWithChildren<{
  onClick: () => void;
}>): React.ReactNode {
  return (
    <Button onClick={onClick} data-testid="add-project-btn">
      <span className="flex items-center gap-space-sm">
        <PlusCircleIcon />
        <span>{children}</span>
      </span>
    </Button>
  );
}
